import { WppTypography } from '@wppopen/components-library-react'
import { sortIcon } from './utils'
import type { IHeaderParams } from 'ag-grid-community'

function HeaderCell({ enableSorting, displayName, column, setSort }: IHeaderParams) {
  const handleHeaderCellClick = () => {
    if (!enableSorting) return

    //list of sort types
    const items: ('asc' | 'desc' | null)[] = ['asc', 'desc', null]
    // current sort type
    const selectedSort = column.getSort()
    // if selected sort type is not in the list, then set it to the first item in the array
    const selectedSortIndex = selectedSort ? items.indexOf(selectedSort) : -1
    //next sort type
    let nextSortType = selectedSortIndex === -1 ? 'asc' : items[selectedSortIndex + 1]

    setSort(nextSortType)
  }

  if (!displayName) return null
  return (
    <div className="ag-header-cell-comp" data-testid="header-cell" onClick={handleHeaderCellClick}>
      <WppTypography type="s-strong">{displayName}</WppTypography>
      {enableSorting && sortIcon(column)}
    </div>
  )
}

export default HeaderCell
